import { mergeWith } from 'lodash';

import { concatArraysCustomizer } from 'hb-react/shared/utils/mergeWith';

// Blocks with no explicit zone are rendered in the default zone.
export const DEFAULT_ZONE = 'default_zone';

// Blocks in the no_zone will not be rendered. This is for pages that support
// multiple templates with blocks that should appear in some but not all templates.
export const NO_ZONE = 'no_zone';

export const byZone = (blocks, zones) => {
  if (!zones) {
    return { [DEFAULT_ZONE]: blocks.map((b) => b.block) };
  }

  const zoneNames = Object.keys(zones);

  return blocks.reduce((result, block) => {
    const zone =
      zoneNames.find((z) => zones[z].includes(block.blockId)) ?? DEFAULT_ZONE;
    const zoneBlocks = result[zone]
      ? [...result[zone], block.block]
      : [block.block];

    return { ...result, [zone]: zoneBlocks };
  }, {});
};

export const withCustomZones = (template, customZones) => {
  // Remove the default zone mappings for the blockIds that are in the customBlocksInZones.
  // We don't want a block to be in two zones at the same time.
  const blockIds = Object.values(customZones).flat();
  const zones = Object.keys(template.zones).reduce((result, zone) => {
    result[zone] = template.zones[zone].filter(
      (blockId) => !blockIds.includes(blockId),
    );

    return result;
  }, {});

  return mergeWith(
    { ...template, zones },
    {
      zones: customZones,
    },
    concatArraysCustomizer,
  );
};
